import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import PageLayout from 'components/common/PageLayout';
import Link from 'components/common/Link';
import Space from 'components/common/Space';
import Typography from 'components/common/Typography';
import useMedia from 'hooks/useMedia';
import { MULTI_FACTOR_AUTHENTICATION } from 'config/flags';
import { useIsSFTYUser } from 'hooks/useIsSFTYUser';

const { Title, Text } = Typography;

type ScreenLink = {
  label: string;
  url: string;
};

type ScreenItem = {
  heading: string;
  description: string;
  link: ScreenLink;
};

const buildItems = function (hideMfa: boolean): ScreenItem[] {
  const items: ScreenItem[] = [];
  if (MULTI_FACTOR_AUTHENTICATION && !hideMfa) {
    items.push({
      heading: 'signInSecurity.extraSecurity.label',
      description: 'signInSecurity.extraSecurity.description',
      link: {
        label: 'signInSecurity.extraSecurity.linkText',
        url: '/signin-security/mfa',
      },
    });
  }
  items.push({
    heading: 'signInSecurity.yourActivity.label',
    description: 'signInSecurity.yourActivity.description',
    link: {
      label: 'signInSecurity.yourActivity.linkText',
      url: '/signin-security/activity ',
    },
  });

  return items;
};

const SignInScreen: FC = () => {
  const { t } = useTranslation();
  const items: ScreenItem[] = buildItems(useIsSFTYUser());

  const isMobile = useMedia('(max-width: 62rem)');

  return (
    <PageLayout title={t('signInSecurity.title')}>
      {items.map(e => (
        <React.Fragment key={e.heading}>
          <Space size={isMobile ? 18 : 16} />
          <Title level={2}>{t(e.heading)}</Title>
          <Text>{t(e.description)}</Text>
          <Space size={12} />
          <Link href={e.link.url}>{t(e.link.label)}</Link>
          <Space size={12} />
        </React.Fragment>
      ))}
    </PageLayout>
  );
};

export default SignInScreen;
